import { apiUrl, raiseApiError, type ApiParams } from './api'

interface DownloadOptions {
  params?: ApiParams
  filename: string
}

// Fetch a file endpoint and trigger a browser save. apiClient can't be used
// here because it always parses the response body as JSON; here the body is a
// blob and the session cookie rides the same-origin fetch as usual.
export async function downloadFile(endpoint: string, options: DownloadOptions): Promise<void> {
  const response = await fetch(apiUrl(endpoint, options.params))
  if (!response.ok) {
    await raiseApiError(response, endpoint)
  }

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = options.filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
